import { createAsyncActions } from "~/utils/store";

export var LOAD_CONTAS_PAGAR = createAsyncActions("LOAD_CONTAS_PAGAR");
export var CREATE_CONTA_PAGAR = createAsyncActions("CREATE_CONTA_PAGAR");
export var UPDATE_CONTA_PAGAR = createAsyncActions("UPDATE_CONTA_PAGAR");
export var DELETE_CONTA_PAGAR = createAsyncActions("DELETE_CONTA_PAGAR");
export var MARK_AS_PAID = createAsyncActions("MARK_CONTA_PAGAR_AS_PAID");

export var loadContasPagar = function(filter) {
    return {
        type: LOAD_CONTAS_PAGAR.INIT,
        payload: {
            request: {
                method: "GET",
                url: "/contas-pagar",
                params: filter,
            },
            filter: filter,
        },
    };
};

export var createContaPagar = function(data) {
    return {
        type: CREATE_CONTA_PAGAR.INIT,
        payload: {
            request: {
                method: "POST",
                url: "/contas-pagar",
                data: data,
            },
        },
    };
};

export var updateContaPagar = function(id, data) {
    return {
        type: UPDATE_CONTA_PAGAR.INIT,
        payload: {
            request: {
                method: "PUT",
                url: "/contas-pagar/" + id,
                data: data,
            },
        },
        id: id,
    };
};

export var deleteContaPagar = function(id) {
    return {
        type: DELETE_CONTA_PAGAR.INIT,
        payload: {
            request: {
                method: "DELETE",
                url: "/contas-pagar/" + id,
            },
        },
        id: id,
    };
};

export var markAsPaid = function(id, paidAt) {
    return {
        type: MARK_AS_PAID.INIT,
        payload: {
            request: {
                method: "PUT",
                url: "/contas-pagar/" + id + "/paid",
                data: { paid_at: paidAt },
            },
        },
        id: id,
    };
};
